<aside class="navbarRight">
    <div class="navbarRight-content">
        <div class="item" (click)="hiddenNav()">
            <div nz-tooltip
                    nzTooltipTitle="Ẩn"
                    nzTooltipPlacement="right"
                    class="itemIcon">
                    <i nz-icon class="text-white text-xl" nzType="caret-right" nzTheme="outline"></i>
            </div>
        </div>
        <div class="logoLink"
             title="CSDL Người khuyết tật">
            <svg class="h-8 w-8 text-textLogo"
                 viewBox="0 0 32 32"
                 xmlns="http://www.w3.org/2000/svg"
                 aria-hidden="true">
                <defs>
                    <linearGradient x1="108.695%"
                                    x2="12.439%"
                                    y1="-14.936%"
                                    y2="45.215%"
                                    id="uid11-1">
                        <stop stop-color="#DEEBFF"
                              stop-opacity="0.4"
                              offset="0%"></stop>
                        <stop stop-color="#DEEBFF"
                              offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%"
                                    x2="91.029%"
                                    y1="118.55%"
                                    y2="63.971%"
                                    id="uid11-2">
                        <stop stop-color="#DEEBFF"
                              stop-opacity="0.4"
                              offset="0%"></stop>
                        <stop stop-color="#DEEBFF"
                              offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g>
                    <path d="M15.967 29.362a6.675 6.675 0 0 0 0-9.442l-8.699-8.671-3.957 3.957a1.062 1.062 0 0 0 0 1.5l12.656 12.656zm12.656-14.156L15.967 2.55l-.039.039a6.675 6.675 0 0 0 .028 9.41l8.706 8.667 3.96-3.96a1.062 1.062 0 0 0 0-1.5z"
                          fill="currentColor"></path>
                    <path d="M15.967 11.992a6.675 6.675 0 0 1-.028-9.41L6.91 11.606l4.72 4.721 4.336-4.335z"
                          fill="url(#uid11-1"></path>
                    <path d="M20.295 15.591l-4.328 4.329a6.675 6.675 0 0 1 0 9.442l9.05-9.05-4.722-4.72z"
                          fill="url(#uid11-2"></path>
                </g>
            </svg>
        </div>
        <div *ngFor="let item of items"
             class="item">
            <div (click)="item.handler()"
                 nz-tooltip
                 [nzTooltipTitle]="item.tooltip"
                 nzTooltipPlacement="right"
                 class="itemIcon">
                <i class="text-white text-xl"
                   nz-icon
                   [nzType]="item.icon"
                   nzTheme="outline"></i>
            </div>
        </div>
        <div class="flex-auto"></div>
        <div class="item"
             *ngIf="authQuery.user$ | async as user">
            <div nz-tooltip
                 [nzTooltipTitle]="user.fullName"
                 nzTooltipPlacement="right"
                 class="itemIcon">
                <!-- <j-avatar class="flex"
                          [avatarUrl]="user.avatarUrl"
                          [size]="26">
                </j-avatar> -->
            </div>
        </div>
        <div class="item">
            <a nz-popover
               nzPopoverPlacement="rightBottom"
               [nzPopoverContent]="aboutPopoverTmpl"
               nzPopoverTrigger="click">
                <div nz-tooltip
                     nzTooltipTitle="About"
                     nzTooltipPlacement="right"
                     class="itemIcon">
                    <i class="text-white text-xl"
                       nz-icon
                       nzType="question-circle"
                       nzTheme="outline">
                    </i>
                </div>
            </a>
        </div>
    </div>
</aside>

<ng-template #aboutPopoverTmpl>
  <div class="about-popover">
    <p class="mb-2">Nếu bạn cần hỗ trợ <strong>vui lòng</strong> liên hệ thông tin như sau </p>
    <p class="mb-2">Gửi thu góp ý</p>
    <p class="mb-3">Mọi thắc mắc vui lòng gửi tới <a class="font-semibold" href="email:ascschool@gmail.com">sales@ascvn.com.vn</a>
    </p>
    <a href="http://ascvn.com.vn/" target="_blank">
      <j-button className="btn-primary">Ghé thăm trang chúng tôi</j-button>
    </a>
  </div>
</ng-template>
